import { render } from "./Patient_Home.vue?vue&type=template&id=6236ea68"
import script from "./Patient_Home.vue?vue&type=script&lang=js"
export * from "./Patient_Home.vue?vue&type=script&lang=js"

import "./Patient_Home.vue?vue&type=style&index=0&id=6236ea68&lang=scss"

import exportComponent from "/app/websites/dizztinct/dizztinct-patient/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__